import { useMemo } from 'react';
import { Cell } from '../Cells';

export function useRecentFilesColumns() {

  return useMemo(() => {
    return [
      {
        id: 'name',
        Header: 'Name',
        Cell: (props) => Cell.Name({ ...props }),
        minWidth: 200,
      },
      {
        id: 'createdOn',
        Header: 'Created On',
        Cell: Cell.CreatedOn,
        minWidth: 80,
        maxWidth: 80,
      },
    ].filter(Boolean);
  }, []);
}